import { render, staticRenderFns } from "./product.vue?vue&type=template&id=00428cea"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00428cea')) {
      api.createRecord('00428cea', component.options)
    } else {
      api.reload('00428cea', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=00428cea", function () {
      api.rerender('00428cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stiker/product.vue"
export default component.exports